import React from 'react'
import ReactDOM from 'react-dom'
import ReactAI from 'react-appinsights'
import createBrowserHistory from 'history/lib/createBrowserHistory'
import { isLocalStorageNameSupported } from 'utils/detector'
// import { install } from 'offline-plugin/runtime'
import { useRouterHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import createStore from './store/createStore'
import AppContainer from './containers/AppContainer'
import { reducerKey as authReducerKey } from 'routes/Auth'
import { initialState as authInitialState, localStorageStateSlicer as authLocalStorageStateSlicer } from 'routes/Auth/modules/reducer'
import { reducerKey as discoveryReducerKey } from 'routes/Auth/routes/Discovery'
import { initialState as discoveryInitialState, localStorageStateSlicer as discoveryLocalStorageStateSlicer } from 'routes/Auth/routes/Discovery/modules/reducer'
import merge from 'lodash/merge'
import iframeOnMessage from 'store/iframeOnMessage'

// ========================================================
// Browser History Setup
// ========================================================
const browserHistory = useRouterHistory(createBrowserHistory)({
  basename: __BASENAME__
})

export const localStorageKey = 'omw-prosperity'

const persistStateConfig = {
  key: localStorageKey,
  slicer: (paths) => (state) => ({
    [authReducerKey]: state[authReducerKey] ? authLocalStorageStateSlicer(state[authReducerKey]) : {},
    [discoveryReducerKey]: state[discoveryReducerKey] ? discoveryLocalStorageStateSlicer(state[discoveryReducerKey]) : {}
  }),
  merge: (initialState, persistedState) => merge({}, initialState, persistedState) // use a deep merge rather than the default shallow merge
}
// ========================================================
// Store and History Instantiation
// ========================================================
// Create redux store and sync with react-router-redux. We have installed the
// react-router-redux reducer under the routerKey "router" in src/routes/index.js,
// so we need to provide a custom `selectLocationState` to inform
// react-router-redux of its location.
const initialState = { // initial state of our synchronous reducers that have some values populated form localStorage
  [authReducerKey]: authInitialState,
  [discoveryReducerKey]: discoveryInitialState
}

const store = createStore(initialState, browserHistory, persistStateConfig)
iframeOnMessage(store, { propertyWhitelist: ["discoverySetId"] }) // dispatch actions when iframe messages are received. Whitelisted to only dispatch for events containing the property "discoverySetId".
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: (state) => state.router
})

// ========================================================
// Developer Tools Setup
// ========================================================
/*if (__DEBUG__) {
  if (window.devToolsExtension) {
    window.devToolsExtension.open()
  }
}*/

// ========================================================
// Render Setup
// ========================================================
const MOUNT_NODE = document.getElementById('root')

// Don't try tracking if localStorage is not supported (insights use localStorage) (i.e. incognito mode on iPad), or it will crash the app
const isLocalStorageSupported = isLocalStorageNameSupported()
if (isLocalStorageSupported) {
  ReactAI.init({instrumentationKey:'fbd0f13d-06e2-49aa-b95f-217cea7133e2'}, browserHistory)
}

let render = () => {
  const routes = require('./routes/index').default(store)
  ReactDOM.render(
    <AppContainer
      store={store}
      history={history}
      routes={routes}
      onUpdate={isLocalStorageSupported ? ReactAI.trackRouterChange : undefined}
    />,
    MOUNT_NODE
  )
}

// This code is excluded from production bundle
if (__DEV__) {
  if (module.hot) {
    // Development render functions
    const renderApp = render
    const renderError = (error) => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
    }

    // Wrap render in try/catch
    render = () => {
      try {
        renderApp()
      } catch (error) {
        renderError(error)
      }
    }

    // Setup hot module replacement
    module.hot.accept('./routes/index', () => {
      setTimeout(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      })
    })
  }
}

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
if (__PROD__) {
  require('offline-plugin/runtime').install(); // eslint-disable-line global-require
}

// ========================================================
// Go!
// ========================================================
render()



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/